/**
 * 真爱团守护
 * @author lianghua.fu
 * @date 2022-02-25 09:22:23
 */
import {
  applySnapshot,
  Instance,
  SnapshotIn,
  SnapshotOut,
  getParent,
  getRoot,
  flow,
  types,
} from 'mobx-state-tree';
import { debug, request, utils } from 'lib';
import FinanceModel from 'models/finance-model';

import { globalStore } from 'stores';

const log = debug.create('guard');
const error = debug.create('guard:error');

import { getGlobalStore } from 'stores';

const initState = {};

const GuardMap = types.model('GuardMapModel', {
  1: 0,
  2: 0,
  3: 0,
});

const ViewerModel = types.model('ViewerModel', {
  uid: 0,
  nick_name: '',
  pic: '',
  guard: false, // 是否开通守护
  score: 0, // 本场贡献
  remains: types.optional(GuardMap, {}),
});
const GuarderModel = types.model('GuarderModel', {
  type: types.identifier,
  count: 0, // 总数
  today_add: 0, // 今日新增
  today_total_add: 0, // 今日总
  due: 0, // 即将到期
});

const GuardInfoModel = types
  .model('GuardInfoModel', {
    // fans_list: {},
    exist_love_group: -1, //是否开通真爱团   -1 未开通、0已申请开通，1：申请通过，2：申请被拒绝
    earnings: 0, // 今日真爱团收益
    guarder: types.map(GuarderModel),
  })
  .views((self) => {
    const defaultValue = {
      count: 0,
      today_add: 0,
      today_total_add: 0,
      due: 0,
    };
    return {
      get isOpen() {
        return self.exist_love_group === 1;
      },
      get earningsText() {
        return utils.formatNum(self.earnings, true);
      },
      get star() {
        return self.guarder.get('STAR') || defaultValue;
      },
      get king() {
        return self.guarder.get('KING') || defaultValue;
      },
      get god() {
        return self.guarder.get('GOD') || defaultValue;
      },
      get love() {
        return self.guarder.get('TRUEGROUP') || defaultValue;
      },
    };
  });

const Model = types
  .model('GuardModel', {
    info: types.optional(GuardInfoModel, {}),
    viewList: types.array(ViewerModel),
  })
  .views((self) => {
    return {};
  })
  .actions((self) => {
    const update = (info) => {
      self.info = info;
    };

    const loadGuardInfo = flow(function* () {
      let {
        room: { roomId, isRoomOwner },
      } = getRoot(self);
      let res;
      if (getGlobalStore().isLogin) {
        try {
          res = yield request.cryolite.get(`api/v1/guard/room-guard-info`);
          self.info = res.data;
        } catch (e) {
          console.error(e);
        }
      }
    });

    const loadLoveList = flow(function* () {
      let {
        room: { roomId, isRoomOwner },
      } = getRoot(self);
      let res;
      if (getGlobalStore().isLogin) {
        try {
          res = yield request.cryolite.get(`api/v1/guard/love-group-viewer`);
          self.viewList = res.data.items;
        } catch (e) {
          console.error(e);
        }
      }
    });

    const init = () => {
      loadGuardInfo();
      // loadLoveList()
    };

    return {
      init,
      loadGuardInfo,
      loadLoveList,
      update,
    };
  });

export default {
  initState,
  Model,
};
